import { useEffect, type FC } from 'react';
import { usePickBlock } from 'src/utils/pick-block';
import { BlockEmptyView } from '../block-empty-view';
import { useReadonly } from 'src/hooks/page';
import { useOpenModal } from '@flowus/common/next-modal';
import { ChartConfigPanel } from './chart-config-panel';
import { Modals } from '@flowus/shared';
import { updateBlock } from 'src/redux/managers/block/update';
import { getRecentlyUpdateCollection } from './chart-config-panel/get-recently-update-collection';

interface Props {
  id: string;
}
export const EmptyBlocker: FC<Props> = (props) => {
  const block = usePickBlock(props.id, ['data', 'local'], ['format']);
  const readonly = useReadonly(props.id);
  const openModal = useOpenModal();

  useEffect(() => {
    if (block?.local) {
      // 重置local
      void getRecentlyUpdateCollection();
      updateBlock(props.id, { local: false }, true);
    }
  }, [block?.local, props.id]);
  if (block?.data.format?.chartFormat?.ref?.uuid) {
    return <>{props.children}</>;
  }
  return (
    <BlockEmptyView
      defaultOpenPanel={Boolean(block?.local)}
      readonly={readonly}
      onClick={() => {
        openModal.modal({
          modalId: Modals.CHART_PANEL_ID,
          autoClose: false,
          className: 'rounded-md',
          content: () => {
            return <ChartConfigPanel id={props.id} />;
          },
        });
      }}
      iconProp={{ name: 'IcChartLineSmall', size: 'normal' }}
      text={'添加数据图表'}
    />
  );
};
